import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.startTimer();
  }

  startTimer() {
    setTimeout(() => {
      this.onClose();
    }, 3000);
  }

  onClose() {
    this.element.remove();
  }
}
